<template>
	<div class="zhuanti_main">
		<div class="zhuanti_main_header">
			<div class="zhuanti_main_header_left">
				<div class="zhuanti_main_header_left_title">选择专题</div>
				<div
					class="zhuanti_main_header_left_add zhuanti_main_button pointer"
					@click="addZhuanti()"
				>
					新建专题
				</div>
			</div>
			<div class="zhuanti_main_header_right pointer">
				<img src="https://res.me.news/assets/images/web/关闭.png" alt="" />
			</div>
		</div>

		<div class="zhuanti_main_action">
			<div class="zhuanti_main_action_count"
				>当前已选中({{ this.selectArray.length }})</div
			>
			<div class="zhuanti_main_action_buttons">
				<div
					class="zhuanti_main_action_buttons_item zhuanti_main_button pointer"
					@click="selectAll()"
				>
					全选
				</div>
				<div
					class="zhuanti_main_action_buttons_item zhuanti_main_button pointer"
					@click="clearAll()"
				>
					清除
				</div>
			</div>
		</div>

		<div class="zhuanti_main_search">
			<div class="zhuanti_main_search_item">
				<el-input
					placeholder="搜索专题"
					v-model="search"
					clearable
					prefix-icon="el-icon-search"
				>
				</el-input>
			</div>
			<div class="zhuanti_main_search_line"></div>
		</div>

		<div class="zhuanti_main_content">
			<div
				class="zhuanti_main_content_item pointer"
				v-for="(item, index) in filteredLabelList()"
				:key="index"
			>
				<div
					class="zhuanti_main_content_item_content pointer"
					@click="selectItem(item)"
				>
					<div class="zhuanti_main_content_item_img">
						<img
							src="https://res.me.news/assets/images/web/复选框-默认 (2).png"
							alt=""
							v-if="selectArray.indexOf(item.id) == -1"
						/>
						<img
							src="https://res.me.news/assets/images/web/复选框 (2).png"
							alt=""
							v-else
						/>
					</div>
					<div
						class="zhuanti_main_content_item_title"
						:class="{
							zhuanti_main_content_item_title_sel:
								selectArray.indexOf(item.id) != -1,
						}"
						>{{ item.name }}</div
					>
				</div>
			</div>
		</div>

		<div class="zhuanti_main_bottom">
			<div
				class="zhuanti_main_bottom_btn zhuanti_main_bottom_submit pointer"
				@click="submit()"
			>
				确认
			</div>
			<div
				class="zhuanti_main_bottom_btn zhuanti_main_bottom_exit pointer"
				@click="exit()"
			>
				取消
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: { ticketArray: [], labelList: [] },
	components: {},
	data() {
		return {
			search: "",
			selectArray: [...this.ticketArray],
		};
	},

	mounted() {
		console.log(this.ticketArray);
	},
	methods: {
		selectAll() {
			this.selectArray = [];
			this.filteredLabelList().forEach((element) => {
				this.selectArray.push(element.id);
			});
		}, // 计算属性：根据搜索关键词过滤专题列表
		filteredLabelList() {
			if (!this.search || this.search == "") {
				return this.labelList;
			}

			console.log("searchKeyword", this.search);

			const searchKeyword = this.search.toLowerCase().trim();
			return this.labelList.filter((item) => {
				return item.name && item.name.toLowerCase().includes(searchKeyword);
			});
		},
		clearAll() {
			this.selectArray = [];
		},
		addZhuanti() {
			this.$router.push({ path: "/message/addLabel" });
		},

		selectItem(item) {
			console.log(item);
			if (this.selectArray.indexOf(item.id) == -1) {
				this.selectArray.push(item.id);
			} else {
				this.selectArray.splice(this.selectArray.indexOf(item.id), 1);
			}
		},
		submit() {
			// 获取选中的专题名称列表
			const selectedLabels = this.labelList
				.filter((item) => this.selectArray.includes(item.id))
				.map((item) => item.name);

			// 构造提示信息
			let confirmMessage = "确认勾选以下专题吗？";
			if (selectedLabels.length > 0) {
				confirmMessage += "\n" + selectedLabels.join("\n");
			} else {
				confirmMessage += "\n(未选择任何专题)";
			}
			this.$confirm(confirmMessage, "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			})
				.then(() => {
					this.$emit("zhuanti_submit", this.selectArray);
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消确认",
					});
				});
		},
		exit() {
			this.$emit("zhuanti_exit");
		},
	},
};
</script>
<style scoped>
.zhuanti_main {
	width: 100%;
	height: 60vh;
	border-radius: 15px;
	background: white;

	padding: 20px;
}

.zhuanti_main_header,
.zhuanti_main_action {
	display: flex;
	justify-content: space-between;
	align-items: baseline;
	margin-bottom: 10px;
}

.zhuanti_main_header_left {
	display: flex;
	width: 200px;
	height: 30px;
	align-items: baseline;
}

.zhuanti_main_header_left_title {
	font-size: 18px;
	font-weight: 800;
	margin-right: 10px;
	color: #000;
}

.zhuanti_main_button {
	font-size: 14px;
	font-weight: 800;
	color: blue;
	text-decoration: underline;
}

.zhuanti_main_header_right {
	width: 30px;
	height: 30px;
}

.zhuanti_main_header_right img {
	width: 80%;
	height: 80%;
	object-fit: cover;
}

.zhuanti_main_action_count {
	font-size: 14px;
	font-weight: 800;

	color: #000;
}
.zhuanti_main_action_buttons {
	display: flex;
}

.zhuanti_main_action_buttons_item {
	margin-left: 20px;
}

.zhuanti_main_search_line {
	margin-top: 10px;
	width: 100%;
	height: 2px;
	background: #000;
}

.zhuanti_main_content {
	overflow-y: auto; /* 垂直滚动 */
	height: calc(60vh - 200px); /* 根据需要调整高度 */
}

.zhuanti_main_content_item_content {
	display: flex;
	margin-top: 10px;
	align-items: center;
}

.zhuanti_main_content_item_img {
	width: 30px;
	height: 30px;
}

.zhuanti_main_content_item_img img {
	margin-top: 10%;
	width: 80%;
	height: 80%;
}

.zhuanti_main_content_item_title {
	font-size: 14px;
	font-weight: 600px;
	color: #000;
}

.zhuanti_main_content_item_title_sel {
	color: blue;
}

.zhuanti_main_bottom {
	margin-top: 20px;
	display: flex;
	width: 100%;
	justify-content: space-around;
}

.zhuanti_main_bottom_btn {
	width: 100px;
	height: 40px;
	border-radius: 6px;
	font-size: 18px;
	font-weight: 800;
	color: #fff;
	align-content: center;
	text-align: center;
}

.zhuanti_main_bottom_submit {
	background: #000;
}

.zhuanti_main_bottom_exit {
	background: rgba(0, 0, 0, 0.6);
}
</style>
